/* Relabels Shopify's dynamic checkout button from "Buy it now" to "Buy now".
   The wording comes from Shopify's own payment-button script, not from the
   theme's locale files, so it can't be changed in the usual place - the only
   way is to rewrite it after Shopify renders it.

   Shopify re-renders the button on variant changes and when the cart updates,
   so an observer puts the label back each time rather than setting it once. */
(function () {
  var LABEL = 'Buy now';

  function relabel(root) {
    var buttons = (root || document).querySelectorAll(
      '.shopify-payment-button__button--unbranded'
    );

    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      // Compare trimmed, since Shopify pads the label with whitespace.
      if (button.textContent.trim() !== LABEL) {
        button.textContent = LABEL;
      }
    }
  }

  function start() {
    relabel(document);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        // Only re-check when nodes were actually added, so our own text
        // rewrite doesn't retrigger the observer.
        if (mutations[i].addedNodes.length) {
          relabel(document);
          return;
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
